import { AssignmentType } from '../models/Assignment';

/**
 * Maps the choice made in the create-assignment modal onto the value reported to analytics.
 *
 * `onlyTarget` is optional on SelectedSkillForAssignment because the skill is built before the
 * teacher picks a mode, and the create mutation treats a missing value as the pathway. This mirrors
 * that same truthiness test so the event can never report a type other than the one created.
 */
export const getAssignmentType = (onlyTarget: boolean | undefined): AssignmentType =>
  onlyTarget ? 'skill' : 'skill_pathway';
